module.exports = __webpack_public_path__ + "img/sy-phone.fe42ce1d.svg";